
function Ubicacion() {
  return (
    <svg className="ubicacion-icon" width="16" height="22" viewBox="0 0 16 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7.99999 0.166672C3.80749 0.166672 0.416656 3.5575 0.416656 7.75C0.416656 13.4375 7.99999 21.8333 7.99999 21.8333C7.99999 21.8333 15.5833 13.4375 15.5833 7.75C15.5833 3.5575 12.1925 0.166672 7.99999 0.166672ZM7.99999 10.4583C6.50499 10.4583 5.29166 9.245 5.29166 7.75C5.29166 6.255 6.50499 5.04167 7.99999 5.04167C9.49499 5.04167 10.7083 6.255 10.7083 7.75C10.7083 9.245 9.49499 10.4583 7.99999 10.4583Z" fill="white"/>
    </svg>
  )
}

export default Ubicacion